import * as React from 'react';

export interface IDefaultUndergroundIconProps {
  color: string;
}

export const DefaultUndergroundIcon: React.VFC<IDefaultUndergroundIconProps> = ({ color }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="12" height="14">
      <circle data-testid="underground_icon_default" fill={color} cx="8" cy="8" r="8" />
    </svg>
  );
};
